import { useContext, useRef } from 'react';
import { Box } from '@mantine/core';
import DiscoveryContext from '../DiscoveryContext';
import SingleCustomerContext from '../../Customer360/Customer-Context/SingleCustomerContext';
import IdeaDetails from '../../Customer360/Customer-Table/Right-card/IdeaDetails';
import { useClickOutside } from '@mantine/hooks';
import SideBar from '../../ideaNiv/right-bar/evidence-card/SideBar';

function CustomDrawer( { componentType } : { componentType: 'discovery' | 'customer' } ) {

  const drawerRef = useRef<HTMLDivElement>(null);
  const isDiscoveryPage: boolean = componentType === 'discovery'


  console.log('isDiscoveryPage')

  console.log(isDiscoveryPage)


  const isCustomerPage: boolean = componentType === 'customer'
  const ContextToUse: React.Context<any> = 
  isDiscoveryPage ? DiscoveryContext : SingleCustomerContext;

  const { cardOpened, setCardOpened } = useContext(ContextToUse);

  /* useClickOutside(() => {
    if (cardOpened) {
      setCardOpened(false);
      if(!isDiscoveryPage) {
        setActivityOpened(false);
      }
    }
  }, null, [drawerRef.current]); */

  return (
    <Box
      ref={drawerRef}
      bg='#fff'
      sx={(theme) => ({
        position: 'fixed',
        top: 63,
        right: cardOpened ? 0 : isCustomerPage ? '-620px' : '-496px',
        width: isCustomerPage ? 620 : 496,
        height: 'calc(100vh - 63px)',
        backgroundColor: theme.colors.gray[0],
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        transition: 'right 0.3s ease', 
        zIndex: 1000,
      })}
    >
      <SideBar navToPerspective={null} setActiveSearch={null} reviewMode componentType={componentType}/>
      
    </Box>
  );
}

export default CustomDrawer;